export default class Examinations {
    id: number;
    details: string;
    examinationDate: string;

    constructor(id: number, details: string, examinationDate: string) {
        this.id = id;
        this.details = details;
        this.examinationDate = examinationDate;
    } 
}